import ApiService from "@/core/services/api.service";

export default {
  select (query = {}) {
    return ApiService.query('vehicle_types', query)
  }
}
